module.exports = __webpack_public_path__ + "static/media/imbalanced_tree.2bc3b787.png";